import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form-v7';
import { HandCoins, CircleX } from '@parrot-software/design-system/icons';

import { RadioCardGrid, StepLayout } from '@onboarding/presentation/components/shared';
import type { WizardFormValues } from '@onboarding/presentation/types';

/**
 * Step 3 of the onboarding wizard: Tip acceptance.
 * Renders a 3-column grid with two options: accept or decline tips at terminal.
 */
export const TipStep = () => {
  const { t } = useTranslation('onboarding');
  const { control } = useFormContext<WizardFormValues>();

  const options = useMemo(
    () => [
      {
        value: 'true',
        label: t('steps.tip.options.yes'),
        description: t('steps.tip.options.yesDescription'),
        icon: <HandCoins className="text-primary" size={24} />,
      },
      {
        value: 'false',
        label: t('steps.tip.options.no'),
        description: t('steps.tip.options.noDescription'),
        icon: <CircleX className="text-primary" size={24} />,
      },
    ],
    [t],
  );

  return (
    <StepLayout description={t('steps.tip.description')} title={t('steps.tip.title')}>
      <Controller
        control={control}
        name="tip"
        render={({ field }) => (
          <RadioCardGrid columns={2} onChange={field.onChange} options={options} value={field.value} />
        )}
      />
    </StepLayout>
  );
};
